module.exports = __webpack_public_path__ + "img/document.cb52b05e.svg";